import { Moon, Sun } from "lucide-react";
import * as React from "react";

import { useTheme } from "../../context/ThemeContext";

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      className="btn btn-sm btn-ghost icon-only btn-ring theme-toggle"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? (
        <Sun size="1em" aria-hidden="true" />
      ) : (
        <Moon size="1em" aria-hidden="true" />
      )}
    </button>
  );
};

export default ThemeToggle;
